/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState, useRef, useCallback } from "react";
import { Form, Formik } from 'formik';
import { TextArea2 } from 'components/Dialog';
import Icon from 'components/Icon';
import Checkbox from "components/Form/CheckBox";
import { Label } from "components/Form";
import { debounce } from "lodash";
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';

import {
  Dialog,
  DialogBody,
  DialogCancel,
  DialogConfirm,
  ContentTextArea,
  CardHeader,
  IconsContainer,
  IconAddContainer,
} from './styles';

export default function NotesModalV2({ show, handleClose, idOperation, label, onChange }) {
  const fitinsur = new FitinsurAPI();
  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);
  const mc = new MessageCenter();
  const [visible, setVisible] = useState(show);
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState("");
  const [isRequireAttention, setIsRequireAttention] = useState(false);

  async function handleGetNotes() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationNotes(idOperation)
      .then(response => response.json()).then(data => {
        setIsRequireAttention(data.ret_value.requireAttention);
        setValue(data.ret_value.notes)
        loading.stop();
      })
      .catch((error) => {
        loading.stop();
        mc.error(`There was an error while fetching your data: ${handleGetNotes.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  }

  const handleSubmitNotes = (notes, isRequireAttention) => {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestOperationNotesUpdateV2(idOperation, notes, isRequireAttention)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg);
          loading.stop();
          return;
        }
        handleGetNotes()
        loading.stop();
      })
      .catch(() => {
        loading.stop();
      });
  }


  const myRef = useRef();

  useEffect(() => {
    setValue('');
    setVisible(show);
    if (show) handleGetNotes()
  }, [show]);

  const handleSubmit = () => {
    handleSubmitNotes(value, isRequireAttention);
    setIsEditing(false);
    setValue('');
  }


  return (
    <Dialog canShow={visible} >
      <DialogBody ref={myRef}>
        <CardHeader >
          <div>
            {label}
          </div>
          <IconsContainer>
            <Icon
              name="Close"
              className="icon-close"
              onClick={() => {
                handleClose();
                setIsEditing(false)
                setValue('')
              }}
            />
          </IconsContainer>
        </CardHeader>
        <IconAddContainer>
          <Icon
            name="add"
            className="icon-add"
            onClick={() => {
              setIsEditing(true)
              setValue('')
            }}
          />
          {!isEditing && (
            <>
              <Label>
                <Checkbox
                  type="checkbox"
                  checked={isRequireAttention}
                  onChange={(e) => {
                    setIsRequireAttention(e.target.checked)
                    handleSubmitNotes(null, e.target.checked);
                    onChange && onChange(idOperation, e.target.checked);
                  }}
                />
                <span>Require Attention</span>
              </Label>
            </>
          )}
        </IconAddContainer>
        <Formik
          initialValues={{
            notes: ''
          }}
          onSubmit={() => handleSubmit()}>
          <Form>
            <ContentTextArea>
              <TextArea2
                value={value}
                onChange={(e) => setValue(e.target.value)}
                disabled={!isEditing}
              />
            </ContentTextArea>
            {isEditing && (
              <>
                <DialogCancel
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setIsEditing(false)
                    setValue('')
                  }}
                >
                  Cancel
                </DialogCancel>
                <DialogConfirm type="submit">Confirm</DialogConfirm>
              </>
            )}

          </Form>
        </Formik>
      </DialogBody>
    </Dialog>
  );
}